/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from './select-company.component.scss.shim.ngstyle';
import * as i1 from '@angular/core';
import * as i2 from '@angular/forms';
import * as i3 from '../../../../../../../app/modules/employee/pages/companies/select-company/select-company.component';
import * as i4 from '@angular/common';
import * as i5 from '../../../../../../../app/modules/employee/service/company/company.service';
const styles_SelectCompanyComponent:any[] = [i0.styles];
export const RenderType_SelectCompanyComponent:i1.RendererType2 = i1.ɵcrt({encapsulation:0,
    styles:styles_SelectCompanyComponent,data:{}});
function View_SelectCompanyComponent_1(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),3,'option',([] as any[]),
      [[8,'selected',0]],(null as any),(null as any),(null as any),(null as any))),
      i1.ɵdid(1,147456,(null as any),0,i2.NgSelectOption,[i1.ElementRef,i1.Renderer2,
          [8,(null as any)]],{value:[0,'value']},(null as any)),i1.ɵdid(2,147456,(null as any),
          0,i2.ɵq,[i1.ElementRef,i1.Renderer2,[8,(null as any)]],{value:[0,'value']},
          (null as any)),(_l()(),i1.ɵted(3,(null as any),['','']))],(_ck,_v) => {
    const currVal_1:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,1,0,currVal_1);
    const currVal_2:any = i1.ɵinlineInterpolate(1,'',_v.context.$implicit.id,'');
    _ck(_v,2,0,currVal_2);
  },(_ck,_v) => {
    const currVal_0:any = _v.context.$implicit.selected;
    _ck(_v,0,0,currVal_0);
    const currVal_3:any = _v.context.$implicit.name;
    _ck(_v,3,0,currVal_3);
  });
}
export function View_SelectCompanyComponent_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[i1.ɵqud(402653184,1,{textarea:0}),(_l()(),i1.ɵeld(1,0,[[1,0],['input',
      1]],(null as any),4,'select',[['class','form-control']],(null as any),[[(null as any),
      'change']],(_v,en,$event) => {
    var ad:boolean = true;
    var _co:i3.SelectCompanyComponent = _v.component;
    if (('change' === en)) {
      const pd_0:any = ((<any>_co.change($event)) !== false);
      ad = (pd_0 && ad);
    }
    return ad;
  },(null as any),(null as any))),(_l()(),i1.ɵted(-1,(null as any),['\n    '])),(_l()(),
      i1.ɵand(16777216,(null as any),(null as any),1,(null as any),View_SelectCompanyComponent_1)),
      i1.ɵdid(4,802816,(null as any),0,i4.NgForOf,[i1.ViewContainerRef,i1.TemplateRef,
          i1.IterableDiffers],{ngForOf:[0,'ngForOf']},(null as any)),(_l()(),i1.ɵted(-1,
          (null as any),['\n'])),(_l()(),i1.ɵted(-1,(null as any),['\n']))],(_ck,_v) => {
    var _co:i3.SelectCompanyComponent = _v.component;
    const currVal_0:any = _co.companiesOptions;
    _ck(_v,4,0,currVal_0);
  },(null as any));
}
export function View_SelectCompanyComponent_Host_0(_l:any):i1.ɵViewDefinition {
  return i1.ɵvid(0,[(_l()(),i1.ɵeld(0,0,(null as any),(null as any),2,'app-select-company',
      ([] as any[]),(null as any),(null as any),(null as any),View_SelectCompanyComponent_0,
      RenderType_SelectCompanyComponent)),i1.ɵprd(5120,(null as any),i2.NG_VALUE_ACCESSOR,
      (p0_0:any) => {
        return [p0_0];
      },[i3.SelectCompanyComponent]),i1.ɵdid(2,49152,(null as any),0,i3.SelectCompanyComponent,
      [i1.Renderer2,i5.CompanyService],(null as any),(null as any))],(null as any),
      (null as any));
}
export const SelectCompanyComponentNgFactory:i1.ComponentFactory<i3.SelectCompanyComponent> = i1.ɵccf('app-select-company',
    i3.SelectCompanyComponent,View_SelectCompanyComponent_Host_0,{companyId:'companyId'},
    {},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY29tcGFuaWVzL3NlbGVjdC1jb21wYW55L3NlbGVjdC1jb21wYW55LmNvbXBvbmVudC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9EOi9pbmV0cHViL3d3d3Jvb3Qva2FpemVuLW5nL3NyYy9hcHAvbW9kdWxlcy9lbXBsb3llZS9wYWdlcy9jb21wYW5pZXMvc2VsZWN0LWNvbXBhbnkvc2VsZWN0LWNvbXBhbnkuY29tcG9uZW50LnRzIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY29tcGFuaWVzL3NlbGVjdC1jb21wYW55L3NlbGVjdC1jb21wYW55LmNvbXBvbmVudC5odG1sIiwibmc6Ly8vRDovaW5ldHB1Yi93d3dyb290L2thaXplbi1uZy9zcmMvYXBwL21vZHVsZXMvZW1wbG95ZWUvcGFnZXMvY29tcGFuaWVzL3NlbGVjdC1jb21wYW55L3NlbGVjdC1jb21wYW55LmNvbXBvbmVudC50cy5TZWxlY3RDb21wYW55Q29tcG9uZW50X0hvc3QuaHRtbCJdLCJzb3VyY2VzQ29udGVudCI6WyIgIiwiPHNlbGVjdCAjaW5wdXQgKGNoYW5nZSk9XCJjaGFuZ2UoJGV2ZW50KVwiIGNsYXNzPVwiZm9ybS1jb250cm9sXCI+XHJcbiAgICA8b3B0aW9uIHZhbHVlPVwie3tjb21wYW55LmlkfX1cIiAqbmdGb3I9XCJsZXQgY29tcGFueSBvZiBjb21wYW5pZXNPcHRpb25zXCIgW3NlbGVjdGVkXT1cImNvbXBhbnkuc2VsZWN0ZWRcIj57e2NvbXBhbnkubmFtZX19PC9vcHRpb24+XHJcbjwvc2VsZWN0PlxyXG4iLCI8YXBwLXNlbGVjdC1jb21wYW55PjwvYXBwLXNlbGVjdC1jb21wYW55PiJdLCJtYXBwaW5ncyI6IkFBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztvQkNDSTtNQUFBO2FBQUE7VUFBQSw2REFBQTtVQUFBO1VBQUEsZUFBc0c7SUFBOUY7SUFBUixXQUFRLFNBQVI7SUFBUTtJQUFSLFdBQVEsU0FBUjs7SUFBd0U7SUFBeEUsV0FBd0UsU0FBeEU7SUFBc0c7SUFBQTs7OztzREFEMUc7TUFBQTtNQUFBO0lBQUE7SUFBQTtJQUFlO01BQUE7TUFBQTtJQUFBO0lBQWY7RUFBQSxnQ0FBOEQsOENBQzFEO2FBQUE7YUFBQTs0QkFBQSx5Q0FBK0g7VUFBQSx1QkFDMUg7O0lBRDBCO0lBQS9CLFdBQStCLFNBQS9COzs7O29CQ0RKO01BQUE7dUNBQUE7TUFBQTtRQUFBO01BQUEsc0NBQUE7TUFBQTs7Ozs7In0=



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/$$_gendir/app/modules/employee/pages/companies/select-company/select-company.component.ngfactory.ts